import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import { isOptionInstrument } from '../../activeTradePlanModule/utils/optionInstrument';

const SymbolComponent = ({
  top,
  dispatchTop,
  componentSymbol,
  setOptionChoices,
  setOptionChains,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
}) => {
  //let top = props.top;
  //let dispatchTop = props.dispatchTop;
  //let componentSymbol = props.componentSymbol;
  const [textSymbol, setTextSymbol] = useState(''); //need this here so that the this component rerenders when typed into
  const [prevSymbol, setPrevSymbol] = useState('');
  useEffect(() => {
    const nextSymbol = top.symbol === undefined ? '' : top.symbol;
    setPrevSymbol(nextSymbol);
    setTextSymbol(nextSymbol);
    componentSymbol.current = nextSymbol;
  }, [top.symbol]);

  return (
    <div>
      <TextField
        id="outlined-basic"
        size={'small'}
        autoComplete={false}
        // label={<Typography style={{fontSize: 10}}> Symbol < /Typography>}
        //variant="outlined"
        margin={'none'}
        InputProps={{ font: 1 }}
        placeholder={'symbol...'}
        value={textSymbol}
        onChange={(ev) => {
          const nextSymbol = ev.target.value;
          setTextSymbol(nextSymbol);
          componentSymbol.current = nextSymbol;
        }}
        onBlur={(ev) => {
          dispatchTop({ symbol: ev.target.value });
          //console.log("blurring symbol");
          //console.log(prevSymbol.toUpperCase());
          //console.log(ev.target.value.toUpperCase());
          //console.log(top.instrument)
          if (prevSymbol.toUpperCase() !== ev.target.value.toUpperCase()) {
            setOptionChoices({});
            setOptionChains({});
            setPrevSymbol(ev.target.value);
            if (isOptionInstrument(top.instrument)) {
              if (
                finishedRenderingOptionChain &&
                setFinishedRenderingOptionChain
              ) {
                setFinishedRenderingOptionChain(false);
                //console.log("setting to false");
                //console.log(finishedRenderingOptionChain);
              }
            }
          }
        }}
        //required
      />
    </div>
  );
};

export default SymbolComponent;
